export enum LocalStorageKeys {
    CSV = 'csv-data',
    Tour = 'tour'
}